import { useEffect } from "react";
import { getLcn } from "~/utils/labeled-classnames";
import { randomLogoUrl } from "~/utils/paths";
import { useCommonAppContext } from "../contexts/CommonAppContext";
import { signInCloseMessage } from "~/utils/csrf-token-utils";

// IMPORTANT: this component and route must be nested inside of the Base component for the site
// or it won't have access to the CommonAppContext
export default function SignInSuccess() {
  const { currentSite } = useCommonAppContext();

  const lcn = getLcn({
    signInSuccess: [
      'flex items-center justify-center min-h-[100dvh] w-full',
      'text-center text-2xl'
    ]
  });
  useEffect(() => {
    let messageSent = false;

    const sendCloseMessage = () => {
      if (messageSent) return;
      messageSent = true;
      window.opener?.postMessage(signInCloseMessage, '*');
    };

    // if user closes popup early before the timeout fires
    window.addEventListener('pagehide', sendCloseMessage);

    setTimeout(() => {
      sendCloseMessage();
      window.close();
    }, 1500);
  }, [])

  if (!currentSite) return null;

  return (
    <div className={lcn.signInSuccess}>
      <div>
        <div className='mb-3'>
          <img src={randomLogoUrl(currentSite.name)} className='w-40 h-auto rounded-lg' alt={`Logo for ${currentSite.name}`} />
        </div>
        <div>Ok, you're in!</div>
      </div>
    </div>
  );
};

